// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-swbl-ahgsLstd-index-main_right_content-32osx","table":"components-swbl-ahgsLstd-index-table-2qPuw"};


//////////////////
// WEBPACK FOOTER
// ./components/swbl/ahgsLstd/index.css
// module id = 818
// module chunks = 0